// extracted by mini-css-extract-plugin
export default {"logEntriesAccordianList":"LogEntriesAccordianList_logEntriesAccordianList__WjtjF","logEntriesAccordianItem":"LogEntriesAccordianList_logEntriesAccordianItem__iOWCS"};